import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../AppContextProvider";
import { WalletProviderContext } from "../walletprovider/WalletProvider";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBSelect,
  MDBInput,
} from "mdb-react-ui-kit";

export default function NewFolderModal(props) {
  const { selectedAccount } = useContext(WalletProviderContext);
  const context = useContext(AppContext);
  const [selectedPath, setSelectedPath] = useState("");
  const [newPath, setNewPath] = useState("");
  const [folderList, setFolderList] = useState([]);

  const fixedPath = props.modalParam?.fixedPath;
  const hasFixedPath = fixedPath != null;

  useEffect(() => {
    if (props.modalParam) {
      if (hasFixedPath) {
        setSelectedPath(fixedPath);
      } else {
        const folderNames = (props.modalParam.folderNames || [])
          .filter((k) => !k.includes("Imported"))
          .filter((k) => k !== "/");
        let array = [{ text: "", hidden: true }];
        if (folderNames !== undefined) {
          const folderItems = folderNames.map((name) => {
            return { text: name, value: name };
          });
          array = array.concat(folderItems);
        }
        setFolderList(array);
      }
    }
  }, []);

  const displayPath = hasFixedPath
    ? (fixedPath === "/" ? "/User Files" : `/User Files${fixedPath}`)
    : selectedPath;

  const createFolderAndClose = async () => {
    const parentPath = hasFixedPath ? fixedPath : selectedPath;
    props.modalParam.createFolder(parentPath, newPath).then(() => {
      context.onSetIsRender();
    });
  };

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="new-folder-modal">
        <MDBModalDialog scrollable centered size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <div className="title-text">New Folder</div>
              <button
                type="button"
                className="button outline medium"
                onClick={() => props.hideModal()}
                style={{ minWidth: "unset" }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.06056 8.00001L11.5303 5.53028C11.8233 5.23731 11.8233 4.7627 11.5303 4.46973C11.2373 4.17676 10.7627 4.17676 10.4697 4.46973L8.00001 6.93946L5.53028 4.46973C5.23731 4.17676 4.7627 4.17676 4.46973 4.46973C4.17676 4.7627 4.17676 5.23731 4.46973 5.53028L6.93946 8.00001L4.46973 10.4697C4.17676 10.7627 4.17676 11.2373 4.46973 11.5303C4.61621 11.6768 4.80762 11.75 5 11.75C5.19238 11.75 5.38379 11.6768 5.53027 11.5303L8 9.06056L10.4697 11.5303C10.6162 11.6768 10.8076 11.75 11 11.75C11.1924 11.75 11.3838 11.6768 11.5303 11.5303C11.8232 11.2373 11.8232 10.7627 11.5303 10.4697L9.06054 8.00001H9.06056Z"
                    fill="#ffffff"
                  />
                </svg>
              </button>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="path-select-div">
                <div className="path-text-div">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16.2803 15.5301L19.2803 12.5301C19.3499 12.4605 19.4052 12.3779 19.4429 12.2869C19.4806 12.1959 19.5 12.0984 19.5 11.9999C19.5 11.9014 19.4806 11.8039 19.4429 11.7129C19.4052 11.6219 19.3499 11.5393 19.2803 11.4696L16.2803 8.46964C16.2106 8.4 16.128 8.34477 16.037 8.30708C15.946 8.2694 15.8485 8.25 15.75 8.25C15.6516 8.25 15.554 8.2694 15.4631 8.30708C15.3721 8.34477 15.2894 8.4 15.2198 8.46964C15.1501 8.53927 15.0949 8.62194 15.0572 8.71292C15.0195 8.8039 15.0001 8.90141 15.0001 8.99989C15.0001 9.09836 15.0195 9.19588 15.0572 9.28686C15.0949 9.37784 15.1501 9.4605 15.2198 9.53014L16.9395 11.2499L5.24985 11.25C5.05098 11.25 4.86025 11.329 4.71963 11.4696C4.579 11.6103 4.5 11.801 4.5 11.9999C4.5 12.1987 4.579 12.3895 4.71963 12.5301C4.86025 12.6707 5.05098 12.7497 5.24985 12.7497L16.9395 12.7499L15.2198 14.4696C15.0791 14.6103 15.0001 14.801 15.0001 14.9999C15.0001 15.1988 15.0791 15.3895 15.2198 15.5301C15.3604 15.6708 15.5511 15.7498 15.75 15.7498C15.9489 15.7498 16.1396 15.6708 16.2803 15.5301Z"
                      fill="#ffffff"
                    />
                  </svg>
                  <span>{displayPath + (newPath.length > 0 ? "/" + newPath : "")}</span>
                </div>
                <div className="select-div">
                  {!hasFixedPath && (
                    <MDBSelect
                      data={folderList}
                      onValueChange={(val) => setSelectedPath(val.value)}
                      value={selectedPath}
                      label={
                        <div className="select-folder-div">
                          <span>Select Folder</span>
                        </div>
                      }
                    />
                  )}
                  <MDBInput
                    label="New Folder"
                    id="form1"
                    type="text"
                    onChange={(event) => setNewPath(event.target.value)}
                  />
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <div className="info-div"></div>
              <div className="actions-button-div">
                <button className="button subtle medium " onClick={() => props.hideModal()}>
                  <span className="text">Cancel</span>
                </button>
                <button
                  className="button dashboard medium "
                  disabled={newPath.length === 0}
                  onClick={() => {
                    props.hideModal();
                    createFolderAndClose();
                  }}
                >
                  <span className="text">Create</span>
                </button>
              </div>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
